import API from './api';

export const authService = {
  // Login user
  login: (credentials) => API.post('/auth/login', credentials),
  
  // Register user (Admin only)
  register: (userData) => API.post('/auth/register', userData),
  
  // Change password
  changePassword: (passwordData) => API.put('/auth/change-password', passwordData),
  
  // Reset password (for forgot password)
  resetPassword: (passwordData) => API.put('/auth/reset-password', passwordData),
  
  // Get current user profile
  getUserProfile: () => API.get('/auth/profile'),
  
  // Logout
  logout: () => API.post('/auth/logout'),

  // Submit Feedback
  submitFeedback: (feedback) => API.post('/auth/feedback', { feedback }),

  // Forgot Password - Send OTP
  sendForgotPasswordOTP: (username) => API.post('/auth/forgot-password/send-otp', { username }),

  // Forgot Password - Reset with OTP
  resetPasswordWithOTP: (data) => API.post('/auth/forgot-password/reset', data),

  // Google OAuth Login
  googleLogin: (idToken) => API.post('/auth/google', { idToken }),
};
